import { Icon } from "@mdi/react";
import { mdiHelpCircle } from "@mdi/js";
import { useTranslation } from "react-i18next";
import { DropdownMenuItem } from "@acdc2/ui/components/dropdown-menu";
import { Link } from "react-router";
import { routingPaths } from "../navigation/constants";

export function ViewerHelpDropdownMenuItem() {
  const { t } = useTranslation();

  return (
    <DropdownMenuItem asChild>
      <Link to={routingPaths.help}>
        <Icon path={mdiHelpCircle} size="1.25rem" />
        {t("ViewerHelpDropdownMenuItem.label")}
      </Link>
    </DropdownMenuItem>
  );
}
